document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll('.drawer-menu__main_v2 .drawer-menu__link-v2 .opener')
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            const item = link.closest('.drawer-menu__item');
            if (!item) return;

            const subLinks = item.querySelector('.drawer-menu__list--sub');
            // An opener with no submenu used to throw on subLinks.classList and,
            // because preventDefault() had already run, swallowed the tap as well.
            // Bail out first so the link behaves normally instead.
            if (!subLinks) return;

            e.preventDefault();

            const header = item.querySelector('.drawer-menu__link-v2');
            const isOpen = link.getAttribute('aria-expanded') === 'true';

            // Drive every toggle from one source of truth so aria-expanded,
            // .visible and inert can't drift apart.
            link.classList.toggle('visible', !isOpen);
            subLinks.classList.toggle('visible', !isOpen);
            if (header) header.classList.toggle('opened', !isOpen);

            link.setAttribute('aria-expanded', String(!isOpen));
            subLinks.toggleAttribute('inert', isOpen);
        })
    })
})
